import type { Color } from "@msuite/utils/colors";
import type { IncomingInvoiceEventListItem } from "@msuite/utils/types";
import type { IconName } from "@msuite/ui/icons";
import { INCOMING_INVOICE_EVENT_LABEL } from "@msuite/utils/incoming-invoices";

type EventType = IncomingInvoiceEventListItem["type"];

/** The sentence an event reads as, after the person or the system who did it. */
export const EVENT_LABEL = INCOMING_INVOICE_EVENT_LABEL;

/** The marker an event is drawn with on the timeline's line. */
export const EVENT_MARKER: Record<EventType, { icon: IconName; color: Color }> = {
	received: { icon: "Mail", color: "blue" },
	read: { icon: "ScanText", color: "violet" },
	read_failed: { icon: "ScanText", color: "rose" },
	checked: { icon: "ClipboardCheck", color: "gray" },
	approval_requested: { icon: "UserCheck", color: "amber" },
	approved: { icon: "CircleCheck", color: "emerald" },
	rejected: { icon: "CircleX", color: "rose" },
	decision_taken_back: { icon: "Undo2", color: "gray" },
	state_changed: { icon: "ArrowRightLeft", color: "blue" },
	cost_allocation_suggested: { icon: "Sparkles", color: "violet" },
	cost_allocation_changed: { icon: "Split", color: "blue" },
	cost_allocation_cleared: { icon: "Split", color: "gray" },
	field_changed: { icon: "Pencil", color: "gray" },
	duplicate_detected: { icon: "Copy", color: "rose" },
	duplicate_dismissed: { icon: "CopyX", color: "emerald" },
	duplicate_merged: { icon: "Merge", color: "violet" },
	merged_into: { icon: "Merge", color: "gray" },
	reminder_received: { icon: "BellRing", color: "rose" },
	approval_withdrawn: { icon: "UserMinus", color: "gray" },
	payment_exported: { icon: "Landmark", color: "emerald" },
	payment_reverted: { icon: "Undo2", color: "rose" },
	iban_confirmed: { icon: "Landmark", color: "emerald" },
	approval_skipped: { icon: "SkipForward", color: "gray" },
	amount_reduced: { icon: "Scissors", color: "orange" },
	reduction_lifted: { icon: "Scissors", color: "gray" },
	delivery_note_linked: { icon: "Truck", color: "blue" },
	delivery_note_unlinked: { icon: "Truck", color: "gray" },
	approvals_reset: { icon: "RotateCcw", color: "red" },
};
